import { render, staticRenderFns } from "./T1RegionsTags.vue?vue&type=template&id=9b193d22&scoped=true&"
import script from "./T1RegionsTags.vue?vue&type=script&lang=js&"
export * from "./T1RegionsTags.vue?vue&type=script&lang=js&"
import style0 from "./T1RegionsTags.vue?vue&type=style&index=0&id=9b193d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b193d22",
  null
  
)

export default component.exports